import { useEventTrackerService } from "@vahak/core/dist/_services/hooks/useEventTrackerService";
import { GA4LoginOrRegistrationModalEventAttributes } from "@vahak/core/dist/constants/event-names";
import { GenericObject } from "@vahak/core-ui/dist/types/common";

import { LoginEventTracker } from "./loginAuthAnalytics";

interface UseLoginEventTrackingOptions {
    sourceScreen?: string;
    phoneNum?: string | number;
}

export function useLoginEventTracking({ sourceScreen, phoneNum }: UseLoginEventTrackingOptions): LoginEventTracker {
    const { sendGAandMoEngageEvent } = useEventTrackerService();

    return (name: string, data?: GenericObject) => {
        sendGAandMoEngageEvent({
            name,
            data: {
                source_screen: sourceScreen ?? GA4LoginOrRegistrationModalEventAttributes.phone_number_registration,
                phone_number: phoneNum,
                ...data
            }
        });
    };
}
